// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_bAeqAh","composer":"ob_vClFG1","workRole__single_spacing30":"ob_VQjUIj","workRole__multiple":"ob_vvDutk","roles__operator":"ob_dIml0b"};